var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"m-auto p-2 px-3 bg-color-primary text-white rounded-pill w-100",style:({ backgroundColor: _vm.mainColor })},[_c('span',[_vm._v(_vm._s(_vm.orderSelected.statusName))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }